import {Organiser} from "../organizer";
import {LeagueStatus} from "./league-status";
import {ScoringCategorization} from "./scoring/scoring-categorization";
import {GroupScoringConfiguration, IndividualScoringConfiguration} from "./scoring/scoring-configuration";
import {ScoringDefinition} from "./scoring/scoring-definition";
import {VisibilityStatus} from "../visibility-status";
import {CompetitorCount} from "../competitor-count";
import {MultiLangField} from "../multi-lang-field";

export class League {
  id?: number;
  organiser?: Organiser;
  organiserId?: number;
  categoryId?: number;
  name?: string;
  nameEng?: string;
  nameIta?: string;
  nameSlo?: string;
  nameSr?: string;
  nameBs?: string;
  status?: LeagueStatus;
  visibilityStatus?: VisibilityStatus;
  start?: Date;
  end?: Date;
  image?: string;
  imageIcon?: string;
  imageMini?: string;
  imageSmall?: string;
  imageMedium?: string;
  created?: Date;
  modified?: Date;
  defaultLanguage?: number;
  extraLanguages?: number[];
  description?: MultiLangField;
  rules?: MultiLangField
  generalInfo?: MultiLangField;
  scoringInfo?: MultiLangField;
  sportId?: number;
  countries?: number[];
  maxNumberOfEvents?: number;
  scoringCategorizations?: ScoringCategorization[];
  individualScoringConfigurations?: IndividualScoringConfiguration[];
  groupScoringConfigurations?: GroupScoringConfiguration[];
  scoringDefinitions?: ScoringDefinition[];
  competitorCount?: CompetitorCount;
  roundsEnabled?: boolean;
  eventsCount?: number;
  officialWebsite?: string;
  officialMail?: string;
}
